import { ErrorInfo } from '../../utils/error-codes';
import { ExportType, Pagination } from '../interfaces';

export enum SplitCategory {
  PARTNER = 'PARTNER',
  AGENCY = 'AGENCY',
  INDEPENDENT_DEVELOPER = 'INDEPENDENT_DEVELOPER',
  MARKETPLACE = 'MARKETPLACE',
}

export enum SplitUserType {
  SELLER = 'SELLER',
  COLLABORATOR = 'COLLABORATOR',
}

export enum SplitPaymentsActionType {
  ACCEPT = 'ACCEPT',
  REJECT = 'REJECT',
}

export interface SplitPaymentFilters {
  email?: string;
  merchantId?: string;
  fantasyName?: string;
  code?: string;
}

export interface CreateSplitPayment {
  name?: string;
  code: string;
  email: string;
  userType: SplitUserType;
  collaboratorCommission: number;
  collaborationCategory: SplitCategory;
}

export interface SplitPayment {
  id: number;
  name: string;
  category: SplitCategory;
  collaboratorCommission: number;
  collaboratorId: number;
  sellerId: number;
  code: string;
  collaboratorFantasyName: string;
  sellerFantasyName: string;
  status: string;
  sellerAcceptedAt?: string;
  collaboratorAcceptedAt?: string;
  createdAt?: string;
}

export interface SplitPaymentState {
  loading: boolean;
  formLoading: boolean;
  error: boolean;
  errorInfo?: ErrorInfo;
  allSplitPayments?: {
    data: SplitPayment[];
  } & Pagination;
  createSplitPaymentPayload?: CreateSplitPayment;
  requestSuccess: boolean;
  collaboratorEmailValidated?: boolean;
  selectedUserType?: string;
  step: number;
  collaborationIdSelected?: number;
  exportType?: ExportType;
  export: {
    loading: boolean;
    error: boolean;
    errorInfo?: ErrorInfo;
    show: boolean;
    data?: string;
  };
}
